export default __webpack_public_path__ + "static/media/yelp_Camp.56798f33.png";